import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "SiteSlice";

export const getSite = createAsyncThunk(
  `${namespace}/Site`,
  async (body, { rejectWithValue }) => {
    const api = "get_site_lists";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getSiteID = createAsyncThunk(
  `${namespace}/SiteID`,
  async ({sid}, { rejectWithValue }) => {
    const api = "get_site_id";
    const replace = { 
      search: "{site}",
      replace: sid
    };
    const opt = {
      replace: replace,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateSiteID = createAsyncThunk(
  `${namespace}/updateSiteID`,
  async (body, { rejectWithValue }) => {
    const api = "update_site_id";
    const replace = { 
      search: "{site}",
      replace: body.id
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteSiteID = createAsyncThunk(
  `${namespace}/deleteSiteID`,
  async (body, { rejectWithValue }) => {
    const api = "delete_site";
    const replace = { 
      search: "{site}",
      replace: body.id
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addSite = createAsyncThunk(
  `${namespace}/addSite`,
  async (body, { rejectWithValue }) => {
    const api = "add_site";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  site: {
    id: "",
    description: "",
    short_description: "",
  },
  sites: [],
  loading: false,
  error: false,
};

const SiteSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    updateSite(state, action) {
      return { ...state, site: action.payload };
    },

    resetList(state) {
      return {
        ...state, 
        site: initialState.site,
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSite.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getSite.fulfilled, (state, action) => {
        state.loading = false;
        state.sites = action.payload;
      })
      .addCase(getSite.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(getSiteID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getSiteID.fulfilled, (state, action) => {
        state.loading = false;
        state.site = action.payload;
      })
      .addCase(getSiteID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(updateSiteID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateSiteID.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateSiteID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(addSite.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addSite.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addSite.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(deleteSiteID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteSiteID.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteSiteID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { resetList, updateSite } = SiteSlice.actions;
export default SiteSlice.reducer;